module.exports = __webpack_public_path__ + "img/nutrision.5804a3db.svg";